<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="580"
      content-class="rounded-lg"
      scrollable
      @keydown.esc="dialog = false"
    >
      <v-card>
        <v-card-title class="h6">
          <span class="black--text text-uppercase font-weight-bold">{{title}}</span>
          <v-spacer></v-spacer>
          <v-btn text small color="pink" class="mr-n4" @click="modalHide">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0" id="contener">
          <v-form ref="formAddAddress" role="form">
            <div class="py-0">
              <v-divider class="d-none"></v-divider>
            </div>
            <v-row align="center" justify="center">
              <v-col cols="12">
                <div class="pb-4">
                  <div class="text-body-1 font-weight-bold pb-1">Label Alamat</div>
                  <v-text-field
                    v-model="name"
                    :rules="rules.name"
                    validate-on-blur
                    single-line
                    outlined
                    class="rounded-lg text-body-1"
                    height="45"
                    dense
                    placeholder="Contoh : Kantor, Rumah, Kos"
                    hide-details="auto"
                  ></v-text-field>
                </div>
                <div class="pb-4">
                  <div class="text-body-1 font-weight-bold pb-1">Nama Penerima</div>
                  <v-text-field
                    v-model="receipt_name"
                    :rules="rules.receipt_name"
                    validate-on-blur
                    single-line
                    outlined
                    class="rounded-lg text-body-1"
                    height="45"
                    dense
                    placeholder="Isi Nama Lengkap"
                    hide-details="auto"
                  ></v-text-field>
                </div>
                <div class="pb-4">
                  <div class="text-body-1 font-weight-bold pb-1">Nomor Telepon</div>
                  <v-text-field
                    v-model="mobilephone"
                    :rules="rules.mobilephone"
                    @keypress="onlyNumber"
                    @paste.prevent
                    single-line
                    outlined
                    class="rounded-lg text-body-1"
                    height="45"
                    dense
                    placeholder="081234567890"
                    hide-details="auto"
                  ></v-text-field>
                </div>
                <div class="pb-4">
                  <div class="text-body-1 font-weight-bold pb-1">Provinsi</div>
                  <v-autocomplete
                    v-model="province"
                    :rules="rules.province"
                    :items="provinces"
                    item-text="provinsi_name"
                    item-value="id"
                    return-object
                    single-line
                    outlined
                    class="rounded-lg text-body-1"
                    height="45"
                    dense
                    hide-details="auto"
                    no-data-text="Tidak ada data"
                    @change="changeProvince(province.id)"
                  ></v-autocomplete>
                </div>
                <div class="pb-4" v-if="province">
                  <div class="text-body-1 font-weight-bold pb-1">Kota/Kabupaten</div>
                  <v-autocomplete
                    v-model="city"
                    :rules="rules.city"
                    :items="cities"
                    :item-text="item => item.type + ' ' + item.kabupaten_name"
                    item-value="id"
                    return-object
                    single-line
                    outlined
                    class="rounded-lg text-body-1"
                    height="45"
                    dense
                    hide-details="auto"
                    no-data-text="Tidak ada data"
                    @change="changeCity(city.id)"
                  >
                    <template v-slot:item="{item}">{{ item.type }} {{ item.kabupaten_name }}</template>
                    <template v-slot:selection="{item}">{{ item.type }} {{ item.kabupaten_name }}</template>
                  </v-autocomplete>
                </div>
                <div class="pb-4" v-if="city" id="coba">
                  <div class="text-body-1 font-weight-bold pb-1">Kecamatan</div>
                  <v-autocomplete
                    v-model="subdistrict"
                    :rules="rules.subdistrict"
                    :items="subdistricts"
                    item-text="kecamatan_name"
                    item-value="id"
                    return-object
                    single-line
                    outlined
                    class="rounded-lg text-body-1"
                    height="45"
                    dense
                    hide-details="auto"
                    no-data-text="Tidak ada data"
                    @change="changeSubdistrict(subdistrict.postal_code)"
                  ></v-autocomplete>
                </div>
                <div class="pb-4" v-if="city">
                  <div class="text-body-1 font-weight-bold pb-1">Kode Pos</div>
                  <v-col cols="6" class="pa-0">
                    <v-text-field
                      v-model="zipcode"
                      single-line
                      outlined
                      class="rounded-lg text-body-1"
                      height="45"
                      dense
                      placeholder="Kode Pos"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </div>
                <div class="pb-4" v-if="city">
                  <div class="text-body-1 font-weight-bold pb-1">Alamat Lengkap</div>
                  <v-textarea
                    v-model="detail"
                    :rules="rules.detail"
                    single-line
                    outlined
                    class="rounded-lg text-body-1"
                    placeholder="Isi nama jalan, nomor rumah, nama gedung, dsb"
                    hide-details="auto"
                    no-resize
                  ></v-textarea>
                </div>
                <div class="pb-4">
                  <div class="text-body-1 font-weight-bold pb-1">Atur Lokasi</div>
                  <v-col cols="6" class="pa-0">
                    <!-- <v-text-field
                      single-line
                      outlined
                      class="rounded-lg text-body-1"
                      height="45"
                      dense
                      placeholder="Cari Lokasi"
                      hide-details="auto"
                    ></v-text-field>-->
                    <!-- <GoogleMap /> -->
                  </v-col>
                  <div class="pt-1">
                    <GoogleMap />
                    LatLon: {{latitude}}, {{longitude}}
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#272727"
            depressed
            class="text-capitalize font-weight-bold rounded-lg white--text"
            height="45"
            width="150"
            @click="saveAddress"
          >Simpan</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import $ from "jquery";
import GoogleMap from "./GoogleMap.vue";

export default {
  components: {
    GoogleMap
  },
  data() {
    return {
      rules: {
        name: [v => !!v || "Label Alamat tidak boleh kosong"],
        receipt_name: [v => !!v || "Nama Penerima tidak boleh kosong"],
        mobilephone: [
          v => !!v || "Nomor Telepon tidak boleh kosong",
          v => (v.length > 9 && v.length < 14) || "Format tidak sesuai"
        ],
        province: [v => !!v || "Provinsi tidak boleh kosong"],
        city: [v => !!v || "Kota tidak boleh kosong"],
        subdistrict: [v => !!v || "Kecamatan tidak boleh kosong"],
        detail: [
          // v => !!v || "Detail tidak boleh kosong",
          v => v.length > 20 || "Minimal 20 karakter"
        ]
      },
      title: "Tambah Alamat",
      id: "",
      name: "",
      detail: "",
      province: null,
      city: null,
      subdistrict: null,
      zipcode: "",
      receipt_name: "",
      mobilephone: "",
      // longitude: "",
      // latitude: "",
      dialog: false
    };
  },
  props: {},
  computed: {
    latitude: {
      get() {
        return this.$store.state.kiriminaja.latitude;
      },
      set(newName) {
        return newName;
      }
    },
    longitude: {
      get() {
        return this.$store.state.kiriminaja.longitude;
      },
      set(newName) {
        return newName;
      }
    },
    ...mapState("kiriminaja", [
      "provinces",
      "cities",
      "subdistricts"
      // "latitude",
      // "longitude"
    ])
  },
  methods: {
    ...mapMutations(["makeAlert"]),

    ...mapActions("kiriminaja", [
      "getProvince",
      "getCity",
      "getSubdistrict",
      "actLatLon"
    ]),

    modalShow(address) {
      this.dialog = true;
      if (address) {
        this.province = this.provinces.find(
          el => el.id == address.user_address_province_id
        );
        this.city = this.cities.find(
          el => el.id == address.user_address_city_id
        );
        this.subdistrict = this.subdistricts.find(
          el => el.id == address.user_address_subdistrict_id
        );
        this.title = "Ubah Alamat";
        this.id = address.user_address_id;
        this.name = address.user_address_name;
        this.zipcode = address.user_address_zipcode;
        this.detail = address.user_address_detail;
        this.receipt_name = address.user_address_receipt_name;
        this.mobilephone = address.user_address_mobilephone;
        this.longitude = address.user_address_longitude;
        this.latitude = address.user_address_latitude;
      } else {
        this.title = "Tambah Alamat";
        this.id = "";
        this.name = "";
        this.detail = "";
        this.province = null;
        this.city = null;
        this.subdistrict = null;
        this.zipcode = "";
        this.receipt_name = "";
        this.mobilephone = "";
        this.longitude = "";
        this.latitude = "";
      }
    },
    modalHide() {
      this.dialog = false;
    },
    saveAddress() {
      console.log("dett", this.detail.length);
      if (this.detail.length < 20) {
        this.makeAlert({
          code: "error_response",
          type: "error",
          message: "Alamat minimal 20 karakter",
          show: true
        });
        return false;
      }
      if (this.$refs.formAddAddress.validate()) {
        let param = {
          name: this.name,
          detail: this.detail,
          province_id: this.province.id,
          province_name: this.province.provinsi_name,
          city_id: this.city.id,
          city_type: this.city.type,
          city_name: this.city.kabupaten_name,
          subdistrict_id: this.subdistrict.id,
          subdistrict_name: this.subdistrict.kecamatan_name,
          zipcode: this.zipcode,
          receipt_name: this.receipt_name,
          mobilephone: this.mobilephone,
          longitude: this.longitude,
          latitude: this.latitude
        };
        // console.log("parammmm", param);
        // console.log("province", this.province);
        // console.log("city", this.city);
        // console.log("subdistrict", this.subdistrict);
        if (this.id) param["id"] = this.id;
        this.$emit("action", param);
        this.modalHide();
      }
    },
    changeProvince(id) {
      this.city = null;
      this.subdistrict = null;
      this.getCity({
        province_id: id
      });
    },
    changeCity(id) {
      this.subdistrict = null;
      this.zipcode = null;
      this.getSubdistrict({
        city_id: id
      }).then(() => {
        var as = $("#coba").offset().top;
        as -= 90;
        $("#contener").scrollTop(as);
      });
    },
    changeSubdistrict(code) {
      this.zipcode = code;
    }
  },
  created() {
    this.getProvince();
  }
};
</script>